<script setup lang="ts">
import { useWordProcessorStore } from "../useWordProcessorStore";

const wordProcessorInstanceId = inject("instanceId") as string;
const wordProcessorStore = useWordProcessorStore(wordProcessorInstanceId);
const { shouldShowFormatting } = storeToRefs(wordProcessorStore);
</script>

<template>
  <BaseIconButton
    :tooltip="shouldShowFormatting ? 'Hide Formatting' : 'Show Formatting'"
    :active="shouldShowFormatting"
    @click="wordProcessorStore.toggleShouldShowFormatting()"
  >
    <icon name="fa-solid:paragraph" size="16" />
  </BaseIconButton>
</template>
